// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormFooterTabs_FormFooterTabs__ffOjO {
  background: white;
  padding: 24px;
  display: flex;
  justify-content: right;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.FormFooterTabs_FormFooterTabs__ffOjO .FormFooterTabs_btnsWrapper__rtFhn {
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/components/FormFooterTabs/FormFooterTabs.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAAF;AACE;EACE,aAAA;EACA,SAAA;AACJ","sourcesContent":[".FormFooterTabs {\n  background: white;\n  padding: 24px;\n  display: flex;\n  justify-content: right;\n  //margin: 24px -24px 0;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  .btnsWrapper {\n    display: flex;\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FormFooterTabs": `FormFooterTabs_FormFooterTabs__ffOjO`,
	"btnsWrapper": `FormFooterTabs_btnsWrapper__rtFhn`
};
export default ___CSS_LOADER_EXPORT___;
